import { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMainContext } from "../../../Context";
import { check, login, resend } from "../../../Utils/Apis";
import { checkMobile } from "../../../Utils/functions";

const useLogin = () => {
  const [form, setForm] = useState({ mobile: "" });
  const [loading, setLoading] = useState(false);
  const { post } = useMainContext();
  const navigate = useNavigate();
  const login = async () => {
    if (checkMobile(form.mobile)) {
      setLoading(true);
      const { data } = await post(check, form);
      if (data.redirect == "otp") {
        navigate("/otp", { state: form.mobile });
      } else {
        navigate("/password", { state: form.mobile });
      }
      setLoading(false);
    } else {
      toast.error("شماره موبایل صحیح نمی باشد");
    }
  };
  return { login, form, setForm, loading };
};

const useOTP = () => {
  const [form, setForm] = useState({});
  const [loadingResend, setLoadingResend] = useState(false);
  const [loading, setLoading] = useState(false);
  const { post, dispatch, get } = useMainContext();
  const { state } = useLocation();
  const navigate = useNavigate();

  const send = async code => {
    setLoading(true);
    const { data, status } = await post(login, {
      code,
      mobile: state || searchParams.get("resend"),
    });
    setLoading(false);
    if (+status === 200) {
      dispatch("user", data);
      navigate("/dashboard");
    }
  };
  const [showResend, setShowResend] = useState(false);
  const [seconds, setSeconds] = useState(120);
  const [searchParams] = useSearchParams();
  useEffect(() => {
    let interval = null;
    if (!showResend && seconds !== 0) {
      interval = setInterval(() => {
        setSeconds(seconds => seconds - 1);
      }, 1000);
    } else {
      setShowResend(true);
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [showResend, seconds]);
  const secondsToTime = () => {
    let divisor_for_minutes = seconds % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);
    let divisor_for_seconds = divisor_for_minutes % 60;
    let sec = Math.ceil(divisor_for_seconds);
    let obj = {
      m: minutes,
      s: sec,
    };
    return obj;
  };

  const resendCode = async () => {
    setLoadingResend(true);
    const { status } = await get(
      `${resend}?mobile=${state || searchParams.get("resend")}`,
      {
        mobile: state,
      },
      true
    );
    if (+status === 200) {
      setSeconds(120);
      setShowResend(false);
    }
    setLoadingResend(false);
  };
  useEffect(() => {
    if (!searchParams.get("resend")) return;
    resendCode();
    console.log("da", state);
  }, [searchParams]);

  return {
    send,
    form,
    setForm,
    loading,
    secondsToTime,
    loadingResend,
    resendCode,
    showResend,
  };
};

const usePassword = () => {
  const [form, setForm] = useState({});
  const { post, dispatch } = useMainContext();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const send = async () => {
    setLoading(true);
    const { data, status } = await post(login, { mobile: state, ...form });
    if (+status === 200) {
      dispatch("user", data);
      navigate("/dashboard");
    }
    setLoading(false);
  };
  return { send, form, setForm, loading, state };
};

export { useLogin, useOTP, usePassword };
